<template>
  <div id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/about">Over het project</router-link>
  </div>
  <router-view/>
</template>

<style src="./assets/style.css"></style>